import React, { createContext, useState } from 'react';

export const FormContext = createContext();

export const FormContextProvider = ({ children }) => {
	const [forms, setForms] = useState({});

	return <FormContext.Provider value={{ forms, setForms }}>{children}</FormContext.Provider>;
};
